/* eslint-disable import/prefer-default-export */
import RoutesActions from "../../services/routes/actions";
import MarketplaceActions from "../../services/marketplace/actions";

export const changeRoute = (path, history, dispatch) => {
  history.replace(`/${path}`);
  dispatch(RoutesActions.setActualRoute(path));
  dispatch(MarketplaceActions.setInsuranceSelect("all"));
};
